<script setup lang="ts">
import { DIRECTIONAL, ICONS, type IconName } from './icons'

withDefaults(defineProps<{ name: IconName; size?: number; strokeWidth?: number }>(),
  { size: 16, strokeWidth: 1.75 })
</script>

<template>
  <svg viewBox="0 0 24 24" :width="size" :height="size" fill="none" stroke="currentColor"
       :stroke-width="strokeWidth" stroke-linecap="round" stroke-linejoin="round"
       aria-hidden="true" focusable="false" :class="{ 'rtl:-scale-x-100': DIRECTIONAL.has(name) }">
    <path :d="ICONS[name]" />
  </svg>
</template>
